import { formatDateBasedOnTimezone } from "../../utils/date.utils";
import { getValue } from "../../utils/object.utils";

export const transformResultListTableData = (resultList: Array<any>): any[] => {
  const transformDatForTable = resultList.map((result: any): any => {
    return {
      id: getValue(result, "id"),
      label: getValue(result, "label"),
      code: getValue(result, "code"),
      publishDate: formatDateBasedOnTimezone({
        date: getValue(result, "publish_date"),
      }),
      schoolBranchName: getValue(result, "school_branch.name"),
      className: getValue(result, "class.name"),
      // Kept (unformatted, unlike `publishDate` above which is for display)
      // so `EditResultModal` can be opened directly from the list's row
      // actions with the data it needs to populate the form.
      rawPublishDate: getValue(result, "publish_date"),
      resultType: getValue(result, "result_type"),
      totalAttendance: getValue(result, "days_before_exam"),
    };
  });

  return transformDatForTable;
};
